import { combineReducers } from "redux";
import MenuSidebar from "./MenuSidebar";

const MenuSidebarReducer = combineReducers({
  MenuSidebar,
});

export default MenuSidebarReducer;
